module.exports = __webpack_public_path__ + "img/fighting.8ce4fa81.svg";